import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import National from '../DashboardTabs/National';
import Overview from '../DashboardTabs/Regions';
import DivisionalSpecifics from '../DashboardTabs/DivisionalSpecifics';
import { CustomDashboard } from '..';
import { useContext, useState } from 'react';
import DashboardContext from "../../../contexts/DashboardContext";
import Maps from '../DashboardTabs/Maps';
import { MapsProvider } from '../../../contexts/MapsContext';
import { RolesContext } from '../../../contexts/RolesContext';

const NavTabSection = () => {
  const [tabIndex, setTabIndex] = useState(Number(localStorage.getItem('dashboardTabLastSelected')) || 0)
  const { regionListForCM, setDashboardTabIndex } = useContext(DashboardContext)
  const permCheck = useContext(RolesContext).userHasPermission;
  const userCanAccessRegions = permCheck('all', 'Regions');
  const userCanAccessNational = permCheck('all', 'National');
  const userCanAccessDivisionOverview = permCheck('all', 'Division Overview');
  const userCanAccessDivisionalWidgets = permCheck('all', 'Divisional Widgets');
  const userCanAccessMap = permCheck('all', 'Map');

  let tabNames = ['National', 'Regions', 'Division Overview', 'Divisional Widgets', 'Map']

  const handleTabSelection = (index:any) => {
    localStorage.setItem('dashboardTabLastSelected', index)
    setTabIndex(index)
    setDashboardTabIndex(index)
  }

  const tabList = () => {
    return tabNames.map(ele => {
      switch (ele){
        case 'Regions' : 
          return <Tab style={{ display: (userCanAccessRegions && Array.isArray(regionListForCM) && regionListForCM.length) ? 'inline-block' : 'none' }}>{ele}</Tab>
        case 'National' :
          return <Tab style={{ display: (userCanAccessNational && Array.isArray(regionListForCM) && regionListForCM.length) ? 'inline-block' : 'none' }}>{ele}</Tab>
        case 'Division Overview' :
          return <Tab style={{ display: (userCanAccessDivisionOverview) ? 'inline-block' : 'none' }}>{ele}</Tab>
        case 'Divisional Widgets' :
          return <Tab style={{ display: (userCanAccessDivisionalWidgets) ? 'inline-block' : 'none' }}>{ele}</Tab>
        case 'Map' :
          return <Tab style={{ display: (userCanAccessMap) ? 'inline-block' : 'none' }}>{ele}</Tab>
        default: 
          return <Tab>{ele}</Tab>
      }
    })
  }
  
  return (
    <div className='nav-tab-section'>
      <Tabs selectedIndex={tabIndex} onSelect={handleTabSelection}>
        <TabList>
          <div className='nav-tab-section__tablist-inner-container'>
            <div className='nav-tab-section__tab-wrapper'>
              {tabList()}
            </div>
          </div>
        </TabList>

        <TabPanel>
          <National setTabIndex={setTabIndex}/>
        </TabPanel>
        
        <TabPanel style={{ display: (Array.isArray(regionListForCM) && regionListForCM.length) ? 'block' : 'none' }}>
          <Overview setTabIndex={setTabIndex} setDashboardTabIndex={setDashboardTabIndex}/>
        </TabPanel>

        <TabPanel>
          <DivisionalSpecifics setTabIndex={setTabIndex}/>
        </TabPanel>
        <TabPanel>
          <CustomDashboard />
        </TabPanel>
        <TabPanel>
          <MapsProvider>
            <Maps />
          </MapsProvider>
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default NavTabSection